import {useContext, useEffect, useState} from "react"
import {CredentialsContext} from "../../../API/CredentialsContext"
import {Actions} from "../../../Reducer/reducer"
import Table from "./Table"
import Form from "./Form"

const APICalls = () => {

    const [apiState, setApiState] = useState({
        date: new Date().toISOString().split("T")[0],
        requestType: "UPDATE",
        showFailedItems: false,
        sortingOrder: "desc",
        apiResponse: [],
        jsonResponse: [],
        requestId: null,
        searchType: "API",
        ebn: '',
        responseType: ''
    })
    const [checkbox, setCheckbox] = useState([])
    const {dispatch} = useContext(CredentialsContext)
    const authToken = localStorage.getItem("authToken")

    const handleState = (event) => {
        const {name, value} = event.target
        setApiState(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const handleCheckbox = (event) => {
        const index = checkbox.indexOf(event.target.value)
        if (index === -1) {
            setCheckbox([...checkbox, event.target.value])
        } else {
            setCheckbox(checkbox.filter((checkBox) => checkBox !== event.target.value))
        }
    }

    const handleUpdate = async () => {
        try {
            dispatch({type: Actions.ShowLoading})
            const url = `https://app.e-waybill.in/web-app/api?date=${apiState.date}&type=${apiState.requestType}&onlyFailed=${apiState.showFailedItems}&sort=${apiState.sortingOrder}`
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Auth-Token': authToken,
                }
            })

            if (response.ok) {
                const data = await response.json()
                setApiState((prev) => ({
                    ...prev,
                    apiResponse: data
                }))
                console.log("data", data)
            } else {
                console.error("Error in getting response from update/consolidate api")
            }
        } catch (error) {
            console.error("Unable to update", error)
        } finally {
            dispatch({type: Actions.HideLoading})
        }

    }

    const handleDownloadExcel = async () => {

        const url = `https://app.e-waybill.in/web-app/api/csv?x-auth-token=${authToken}`
        const formData = new FormData()
        const isEbnSearch = apiState.searchType === 'EBN';
        formData.append('date', apiState.date)
        formData.append('searchType', apiState.searchType)
        formData.append('ebn', isEbnSearch ? apiState.ebn : '')
        formData.append('ewb', isEbnSearch ? apiState.ebn : '')
        formData.append('type', apiState.requestType)
        formData.append('onlyFailed', apiState.showFailedItems)

        try {
            const response = await fetch(url, {
                method: 'POST',
                body: formData,
            })

            const blob = await response.blob()
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = isEbnSearch ? `ewaybill-history-${apiState.ebn}` : `${apiState.date}-${apiState.requestType}-requests`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            console.log("File downloaded successfully!")
        } catch (error) {
            console.error("Failed to download file:", error)
        }
    }

    const handleViewModal = async ({id, request_id, what}) => {
        try {
            dispatch({type: Actions.ShowLoading})
            const response = await fetch(
                `https://app.e-waybill.in/web-app/api/${what}?request_id=${request_id}&id=${id}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Auth-Token': authToken,
                    }
                })
            if (response.ok) {
                const data = await response.json()
                setApiState((prev) => ({
                    ...prev,
                    jsonResponse: data,
                    requestId: request_id,
                    responseType: what === 'json'? 'Response' : 'Request'
                }))
            } else {
                console.error("Error in getting json response from api")
            }
        } catch (error) {
            console.error("Unable to fetch", error)
        } finally {
            dispatch({type: Actions.HideLoading})
        }
    }

    useEffect(() => {
        setApiState((prev) => ({
            ...prev,
            showFailedItems: checkbox.includes("showFailedItems"),
        }))
    }, [checkbox])


    useEffect(() => {

        const interval = setInterval(() => {
            handleUpdate()
        }, 10000)

        if (!checkbox.includes('autoUpdate')) {
            clearInterval(interval)
        }

        return () => clearInterval(interval)
    })
    const searchByEbnAction = async () => {
        try {
            dispatch({type: Actions.ShowLoading})
            const url = `https://app.e-waybill.in/web-app/api?ewb=${apiState.ebn}`
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Auth-Token': authToken,
                }
            })

            if (response.ok) {
                const data = await response.json()
                setApiState((prev) => ({
                    ...prev,
                    apiResponse: data
                }))
                console.log("data", data)
            } else {
                console.error("Error in getting response from update/consolidate api")
            }
        } catch (error) {
            console.error("Unable to update", error)
        } finally {
            dispatch({type: Actions.HideLoading})
        }

    }
    let searchByApi = <Form
        handleCheckbox={handleCheckbox}
        handleState={handleState}
        handleUpdate={handleUpdate}
        checkbox={checkbox}
        apiState={apiState}/>

    let searchByEbn = <div className={"d-flex justify-content-center align-items-center px-5 mb-3"}>
        <div className="form-group">
            <input type="text" name="ewb" id={"ewb"}
                   value={apiState.ebn}
                   onChange={e => setApiState(a => ({...a, ebn: e.target.value.trim()}))}
                   placeholder={"12 digit e-waybill number"}
                   inputMode={"numeric"}
                   className="form-control" maxLength={12} minLength={12}/>
        </div>
        <div className="mx-3">
            <button className={"btn btn-info"}
                    disabled={!apiState.ebn || apiState.ebn.length !== 12}
                    onClick={searchByEbnAction}>
                Search
            </button>
        </div>
    </div>

    return (
        <div className="pt-2 pb-5 mb-5">
            <div className="d-flex justify-content-center align-items-center px-5 mb-3">
                <h2 className="m-3 text-center">API Calls</h2>
                <div className="form-group ">
                    <select name="searchBy"
                            onChange={(e) => setApiState(p => ({...p, searchType: e.target.value}))}
                            value={apiState.searchType} id="searchBy" className="form-select">
                        <option value={"API"}>Search By API</option>
                        <option value={"EBN"}>Search By E-Waybill</option>
                    </select>
                </div>
            </div>

            {apiState.searchType === 'API' ? searchByApi : searchByEbn}
            <Table
                handleDownloadExcel={handleDownloadExcel}
                searchType={apiState.searchType}
                ebn={apiState.ebn}
                handleViewModal={handleViewModal}
                apiState={apiState}
            />
        </div>
    )
}
export default APICalls